import { createSurveyStyles } from '@sm/webassets';

export const calculateQuestionWidthPercentage = (numOfQuestions: number): string => {
  const width = 100 / numOfQuestions;
  if (width % 1) {
    return `${width.toFixed(2)}%`;
  }
  return `${width}%`;
};

type StyleParams = {
  numOfQuestions: number;
  maxQuestionsPerRow: number;
};

const useStyles = createSurveyStyles(theme => {
  return {
    gridRow: {
      maxWidth: '100%',
      marginBottom: '40px',
    },
    gridItem: ({ numOfQuestions, maxQuestionsPerRow }: StyleParams) => ({
      boxSizing: 'border-box',
      marginBottom: '30px',

      // style below is for the `lgMin` breakpoint
      ...(numOfQuestions > 1 && maxQuestionsPerRow > 1
        ? {
            paddingRight: '20px',
            width: calculateQuestionWidthPercentage(Math.min(maxQuestionsPerRow, numOfQuestions)),
          }
        : { width: '100%' }),
    }),

    // needs inverse ordering and important here to fix JSS media-query bug: https://github.com/cssinjs/jss/issues/1327
    // only visible with multiple QuestionRowLayouts with different configurations
    [`@media (max-width: ${theme.breakpoints?.xs.max})`]: {
      gridItem: {
        paddingRight: `0 !important`,
        width: '100% !important',
      },
    },

    [`@media (min-width: ${theme.breakpoints?.sm.min})`]: {
      gridRow: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
      },
    },

    [`@media (min-width: ${theme.breakpoints?.sm.min}) and (max-width: ${theme.breakpoints?.md.max})`]: {
      // TODO: RAWR-735 bug in JSS - always applies the last item,
      // so if the last has maxQuestionsPerRow > 1 all gridItem are 50% wide
      gridItem: ({ maxQuestionsPerRow }: StyleParams) =>
        maxQuestionsPerRow > 1
          ? {
              paddingRight: '20px',
              // two columns layout
              width: '50%',
            }
          : {
              width: '100%',
            },
    },
    [`@media (min-width: ${theme.breakpoints?.lg.min})`]: {
      gridItem: ({ numOfQuestions }: StyleParams) =>
        numOfQuestions > 1
          ? {
              paddingRight: '20px',
            }
          : {},
    },
  };
});

export default useStyles;
